import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

export class Choice {
  constructor (
      public key: string,
      public value: string
  ) { }
}

@Component({
  selector: 'app-pick-one',
  templateUrl: './pick-one.component.html',
  styleUrls: ['./pick-one.component.css']
})
export class PickOneComponent implements OnInit {

  @Input() key: string;
  @Input() title: string;
  @Input() choices: Choice[];
  @Output() pick: EventEmitter<string> = new EventEmitter();

  formControl: FormControl = new FormControl();

  constructor() { }

  ngOnInit() {
    const saved = localStorage.getItem(`choice.${this.key}`);
    if (saved) {
      this.formControl.setValue(this.choices.find(c => c.key === saved).key);
    } else {
      this.formControl.setValue(this.choices[0].key);
    }
    this.pick.emit(this.formControl.value);
  }

  public pickChoice(choice: string): void {
    this.pick.emit(choice);
    localStorage.setItem(`choice.${this.key}`, this.formControl.value);
  }}